import { useParams, useNavigate } from 'react-router-dom';
import Header from '@cloudscape-design/components/header';
import Button from '@cloudscape-design/components/button';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { TicketDetails } from '../components/TicketDetails';
import { EmptyState } from '../components/EmptyState';
import { useTicket } from '../hooks/useTicket';

export function TicketDetailPage() {
  const { ticketId } = useParams<{ ticketId: string }>();
  const navigate = useNavigate();
  const { ticket, loading, error, refetch } = useTicket(ticketId);

  if (loading) return <EmptyState type="loading" />;
  if (error) return <EmptyState type="error" message={error} onRetry={refetch} />;
  if (!ticket) return <EmptyState type="empty" message="Ticket not found." />;

  return (
    <SpaceBetween size="l">
      <Header
        variant="h1"
        actions={<Button onClick={() => navigate('/')}>Back to list</Button>}
      >
        {ticket.title || ticket.ticketId}
      </Header>
      <TicketDetails ticket={ticket} />
    </SpaceBetween>
  );
}
